import React from 'react'
import { makeStyles } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { megaBytesToBytes, fileToBase64, alertSizeOverLimit } from 'libs/file'

const PHOTO_SIZE_LIMIT = megaBytesToBytes(10)

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  zoneContainer: {
    display: 'block',
    width: '100%',
    height: 96,
    marginTop: 41,
    padding: '30px 33px 29px',
    borderRadius: 4,
    border: 'solid 1px rgb(168 168 168 / 47%)',
    backgroundColor: 'rgb(242 242 242 / 47%)',
    textAlign: 'center',
    borderStyle: 'dashed',
    cursor: 'pointer',
  },
  zoneLine: {
    color: '#404040',
    opacity: 0.37,
  },
  zoneInput: {
    display: 'none',
  },
}))
export default ({ onUploadPush }) => {
  const classes = useStyles()

  const handleFileUpload = async (files) => {
    const isValid = [...files].every((file) => {
      const fileTypes = file.type.split('/')
      if (fileTypes[0] === 'image') {
        return fileTypes[1] !== 'gif'
      }
      return false
    })
    if (!isValid) {
      dispatch(
        MessageAlert.showError({
          message: formatMessage({ id: 'error.400.fileTypeInvalid' }),
        }),
      )
      return
    }
    const base64Files = await Promise.all(
      [...files].map((file) => handleUploadAvatar(file)),
    )
    onUploadPush(base64Files)
  }

  const preventDefaultActions = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const drop = (e) => {
    e.preventDefault()
    e.stopPropagation()

    let dt = e.dataTransfer
    handleFileUpload(dt.files)
  }

  const { formatMessage } = useIntl()
  const dispatch = useDispatch()

  const handleUploadAvatar = (file) =>
    new Promise((resolve) => {
      if (file.size < PHOTO_SIZE_LIMIT) {
        fileToBase64(file).then((fileData) => resolve(fileData))
      } else {
        alertSizeOverLimit(dispatch, formatMessage, PHOTO_SIZE_LIMIT)
      }
    })

  return (
    <>
      <label
        className={classes.zoneContainer}
        onDragLeave={preventDefaultActions}
        onDragEnter={preventDefaultActions}
        onDragOver={preventDefaultActions}
        onDrop={drop}
      >
        <div className={classes.zoneLine}>
          <FormattedMessage id="profile.info.drag" />
        </div>
        <div className={classes.zoneLine}>
          <FormattedMessage id="profile.info.max.size" />
        </div>
        <input
          className={classes.zoneInput}
          type="file"
          onChange={(e) => handleFileUpload(e.target.files)}
          multiple
          accept="image/*"
        />
      </label>
    </>
  )
}
